import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors } from '@flowio/react-theme';
import React from 'react';

var Hint = function Hint(_ref) {
  var children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("span", _extends({}, unhandledProps, {
    css: /*#__PURE__*/css({
      display: 'block',
      marginTop: '8px',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: 'normal',
      color: colors.GRAY_700
    }, process.env.NODE_ENV === "production" ? "" : ";label:Hint;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hpbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWVTIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hpbnQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY29sb3JzIH0gZnJvbSAnQGZsb3dpby9yZWFjdC10aGVtZSc7XG5cbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbnR5cGUgUHJvcHMgPSBSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MU3BhbkVsZW1lbnQ+O1xuXG5jb25zdCBIaW50OiBSZWFjdC5GQzxQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPHNwYW5cbiAgICB7Li4udW5oYW5kbGVkUHJvcHN9XG4gICAgY3NzPXtjc3Moe1xuICAgICAgZGlzcGxheTogJ2Jsb2NrJyxcbiAgICAgIG1hcmdpblRvcDogJzhweCcsXG4gICAgICBmb250U2l6ZTogJzE0cHgnLFxuICAgICAgZm9udFdlaWdodDogJ25vcm1hbCcsXG4gICAgICBsaW5lSGVpZ2h0OiAnbm9ybWFsJyxcbiAgICAgIGNvbG9yOiBjb2xvcnMuR1JBWV83MDAsXG4gICAgfSl9PlxuICAgIHtjaGlsZHJlbn1cbiAgPC9zcGFuPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgSGludDtcbiJdfQ== */")
  }), children);
};

export default Hint;